<template>
    <div id="user-form" :class="{ 'fields-above': fieldsAbove }">
        <form @submit.prevent>
            <h2 v-if="!fieldsAbove && client.first_name">
                {{ t('user-heading_known') }}
            </h2>
            <p v-if="!fieldsAbove">{{ t('user-heading') }}</p>
            <div
                class="form-question"
                v-if="form.askName !== 'no' && (!client.first_name || !client.last_name)"
            >
                <label for="user-first-name"> {{ t('user-name') }} </label>
                <input
                    id="user-first-name"
                    type="text"
                    v-model="first_name"
                    :placeholder="t('user-name_placeholder')"
                    :required="form.askName === 'required'"
                    autocomplete="given-name"
                    :class="{'input-error': errors.first_name}"
                />
                <small v-if="errors.first_name" class="error-message">{{ errors.first_name }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askLastName !== 'no' && (!client.first_name || !client.last_name)"
            >
                <label for="user-last-name"> {{ t('user-last_name') }} </label>
                <input
                    id="user-last-name"
                    type="text"
                    v-model="last_name"
                    :placeholder="t('user-last_name_placeholder')"
                    :required="form.askLastName === 'required'"
                    autocomplete="family-name"
                    :class="{'input-error': errors.last_name}"
                />
                <small v-if="errors.last_name" class="error-message">{{ errors.last_name }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askEmail !== 'no' && !this.client.email"
            >
                <label for="user-email"> {{ t('user-email') }} </label>
                <input
                    id="user-email"
                    type="email"
                    v-model="email"
                    :placeholder="t('user-email_placeholder')"
                    :required="form.askEmail === 'required'"
                    autocomplete="email"
                    :class="{'input-error': errors.email}"
                />
                <small v-if="errors.email" class="error-message">{{ errors.email }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askPhone !== 'no' && !this.client.whatsapp"
            >
                <label for="user-whatsapp"> {{ t('user-phone') }} </label>
                <kv-phone-input
                    id="user-whatsapp"
                    v-model="whatsapp"
                    :default-country="placeCountry"
                    :locale="placeLocale"
                    :required="form.askPhone === 'required'"
                    :error="!!errors.whatsapp"
                    :search-placeholder="t('user-phone_search')"
                    :search-empty-text="t('user-phone_no_results')"
                    @input="isPhoneValid"
                />
                <small v-if="errors.whatsapp" class="error-message">{{ errors.whatsapp }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askBirthdate !== 'no' && !this.client.birthdate"
            >
                <label for="user-birthdate"> {{ t('user-birthdate') }} </label>
                <input
                    id="user-birthdate"
                    type="tel"
                    v-model="birthdate"
                    v-mask="'##/##/####'"
                    :placeholder="t('user-birthdate_placeholder')"
                    :required="form.askBirthdate === 'required'"
                    autocomplete="bday"
                    :class="{'input-error': errors.birthdate}"
                />
                <small v-if="errors.birthdate" class="error-message">{{ errors.birthdate }}</small>
            </div>
        </form>
    </div>
</template>
<style scoped>
input.input-error {
    border: 1px solid #e74c3c !important;
}
input.input-error:focus {
    outline: none;
    border-color: #e74c3c !important;
}
.error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-bottom: -18px;
    margin-top: -5px;
    display: block;
}
</style>
<script>
import { isValidPhone } from "../helpers/phone";

export default {
    name: "form-user",
    props: {
        client: Object,
        place: Object,
        fieldsAbove: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            first_name: this.client.first_name,
            last_name: this.client.last_name,
            email: this.client.email,
            whatsapp: this.client.whatsapp,
            birthdate: this.client.birthdate,
            errors: {
                first_name: null,
                last_name: null,
                email: null,
                whatsapp: null,
                birthdate: null,
            },
            saving: false,
        };
    },
    computed: {
        form() {
            return this.$store.state.form;
        },
        placeCountry() {
            return String((this.place && this.place.country_code) || "BR").toUpperCase();
        },
        placeLocale() {
            return (this.$root && this.$root.locale) || (this.place && this.place.locale) || "pt-BR";
        },
    },
    methods: {
        getData: function () {
            let data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                whatsapp: this.whatsapp ? String(this.whatsapp).trim() : this.whatsapp,
                phone: this.whatsapp ? String(this.whatsapp).trim() : this.whatsapp,
                birthdate: this.birthdate,
                password: this.password,
            };
            return data;
        },
        isEmailValid: function (email) {
            if (email === null || email === "") {
                if (this.form.askEmail === "required") {
                    return false;
                }
                return true;
            }
            var re =
                /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var result = re.test(email);
            return result;
        },
        isPhoneValid: function (phone) {
            if (phone === null || phone === "") {
                if (this.form.askPhone === "required") {
                    return this.errors.whatsapp = this.t("user-phone_required");
                }
                return this.errors.whatsapp = null;
            }

            if (isValidPhone(phone, this.placeCountry)) {
                return this.errors.whatsapp = null;
            }

            return this.errors.whatsapp = this.t("user-phone_invalid");
        },
        isBirthDateValid: function (birthdate) {
            if (birthdate === null) {
                return true;
            }
            let re = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
            let result = re.test(birthdate);
            if (!result) {
                return false;
            }

            let datePieces = birthdate.split("/");
            if (parseInt(datePieces[0]) > 31 || parseInt(datePieces[0]) <= 0) {
                return false;
            }
            if (parseInt(datePieces[1]) > 12 || parseInt(datePieces[1]) <= 0) {
                return false;
            }
            if (
                parseInt(datePieces[2]) > 2019 ||
                parseInt(datePieces[2]) <= 1920
            ) {
                return false;
            }

            return result;
        },
        isValid: function () {
            if (!this.first_name && this.form.askName === "required") {
                this.errors.first_name = this.t("user-name_error");
            } else {
                this.errors.first_name = null;
            }

            this.isPhoneValid(this.whatsapp);

            if (!this.last_name && this.form.askLastName === "required") {
                this.errors.last_name = this.t("user-last_name_error");
            } else {
                this.errors.last_name = null;
            }

            if (this.form.askBirthdate === "required" || this.birthdate) {
                if (!this.isBirthDateValid(this.birthdate)) {
                    this.errors.birthdate = this.t("user-birthdate_error");
                } else {
                    this.errors.birthdate = null;
                }
            }

            if (!this.isEmailValid(this.email)) {
                this.errors.email = this.t("user-email_error");
            } else {
                this.errors.email = null;
            }

            if (Object.values(this.errors).some((error) => error !== null)) {
                return false;
            }
            return true;
        },
    },
};
</script>
